export default __webpack_public_path__ + "static/media/lodging.4ed7245e.svg";